import { ReactNode } from "react";
import { notification } from "antd";
import type { NotificationArgsProps } from "antd";

type NotificationConfig = {
  key?: string;
  title: ReactNode;
  description: ReactNode;
  placement?: NotificationArgsProps["placement"];
  className?: string;
  duration?: number;
  icon?: ReactNode | null;
  actions?: ReactNode;
};

export const useAppNotification = () => {
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (
    type: "success" | "error" | "info" | "warning",
    config: NotificationConfig,
  ) => {
    const {
      key,
      title,
      description,
      placement = "topRight",
      className,
      duration = 4.5,
      actions,
    } = config;

    const base = {
      key,
      title,
      description,
      placement,
      className,
      duration,
      actions,
    };

    if (config.icon === undefined) {
      api.open({ type, ...base });
    } else if (config.icon === null) {
      api.open(base);
    } else {
      api.open({ type, ...base, icon: config.icon });
    }
  };

  const openSuccessNotification = (config: NotificationConfig) => {
    openNotification("success", config);
  };

  const openErrorNotification = (config: NotificationConfig) => {
    openNotification("error", config);
  };

  const closeNotification = (key: string) => api.destroy(key);

  return {
    openSuccessNotification,
    openErrorNotification,
    closeNotification,
    contextHolder,
  };
};
